import React from 'react';
import { Icon, Icons } from '@silverfort/sf-components';

interface ErrorViewProps {
    error?: Error | null;
    errorInfo?: React.ErrorInfo | null;
    onRetry?: () => void;
    title?: string;
    message?: string;
    showDetails?: boolean;
}

const ErrorView: React.FC<ErrorViewProps> = ({ title = 'Unexpected Error' }) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen w-full bg-black">
            <div className="text-center">
                <div className="mb-8">
                    <div className="mx-auto w-14 h-14 bg-sf-gray-1000 border border-sf-gray-800 rounded-lg flex items-center justify-center gap-2 aspect-square">
                        <Icon icon={Icons.CircleError} size={32} />
                    </div>
                </div>
                <h1
                    className="text-sf-white mb-4 font-sf-poppins text-[21px]/[24px] font-medium tracking-[0.529px]"
                    style={{
                        fontFamily: 'Poppins, sans-serif',
                        fontSize: '21px',
                        fontWeight: 500,
                        lineHeight: '24px',
                        letterSpacing: '0.529px',
                        fontStyle: 'normal'
                    }}>
                    {title}
                </h1>
                <div
                    className="text-sf-white text-center max-w-2xl font-sf text-[16px]/[24px] font-normal"
                    style={{
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '16px',
                        fontWeight: 400,
                        lineHeight: '24px',
                        fontStyle: 'normal'
                    }}>
                    <p>We hit an unexpected problem. Please refresh the page and try again.</p>
                    <p>If the issue persists, contact our support team for assistance.</p>
                </div>
            </div>
        </div>
    );
};

export default ErrorView;
